export const FIELD_UPDATED_MODES = {
  ANY_INCLUDING_BLANK: 'any_including_blank',
  ANY_EXCLUDING_BLANK: 'any_excluding_blank',
  BLANK: 'blank',
  SPECIFIC_VALUE: 'specific_value',
  VALUES_ADDED: 'values_added',
  VALUES_REMOVED: 'values_removed',
  DATE_BETWEEN: 'date_between',
  CONTAINS: 'contains_any_of',
  DOES_NOT_CONTAIN: 'contains_none_of',
} as const;
